import { render, staticRenderFns } from "./WordPressOptIn.vue?vue&type=template&id=b99f099e"
import script from "./WordPressOptIn.vue?vue&type=script&lang=js"
export * from "./WordPressOptIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports